import React, { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import LoadingSpinner from "../UserProfile/LoadingSpinner";
import ShopListCard3 from "./ShopListCard3";
import SingleChat2 from "./SingleChat2";

const ProfileShoppingLists = ({
  shoppingListData,
  setShoppingListData,
  activeAccordion,
  setActiveAccordion,
  loading,
  setLoading,
}) => {
  // When someone deletes a product it should be removed in the fav state

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  // Get search parameters from the URL
  const [searchParams] = useSearchParams();
  // Extract 'name' and 'id' from the URL query params
  const listName = searchParams.get("name");
  const urlId = searchParams.get("id");
  // const [activeAccordion, setActiveAccordion] = useState(shoppingListData[0]?.listId);

  // console.log("activeAccordion", activeAccordion, shoppingListData[0]?.listId);
  const initialRenderRef = useRef(true);

  // Effect to handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  console.log("shoppingListData from mylist", shoppingListData);
  useEffect(() => {
    if (initialRenderRef.current && shoppingListData?.length > 0) {
      // setActiveAccordion([]);
      initialRenderRef.current = false;
    }
  }, [listName, urlId, shoppingListData]);

  if (loading) {
    return <LoadingSpinner />;
  }
  // console.log('Active accordian', activeAccordion);

  return (
    <>
      <style jsx>
        {`
          .shoppingList .dropdown-toggle:after {
            display: none;
          }
          .stickyHeader2 {
            position: sticky;
            top: 9rem;
            z-index: 10;
          }
        `}
      </style>
      {!loading && shoppingListData ? (
        shoppingListData?.length > 0 ? (
          <div
            className="row mx-0"
            style={{ marginTop: isSmallScreen ? "" : "4px" }}
          >
            {shoppingListData.map((list, index) => {
              if (
                activeAccordion === list.listId ||
                activeAccordion.length === 0
              )
                return (
                  <ShopListCard3
                    list={list}
                    ownerId={list?.ownerId || null}
                    shoppingListData={shoppingListData}
                    setShoppingListData={setShoppingListData}
                    setActiveAccordion={setActiveAccordion}
                    setLoading={setLoading}
                    index={index}
                    key={list.listId}
                    type={list?.type ?? "myList"}
                  />
                );
            })}
          </div>
        ) : (
          <div style={{ height: "25rem", maxHeight: "25rem" }}>
            <div
              className={`h-100 d-flex justify-content-center align-items-center flex-column px-5`}
              style={{
                minHeight: "10vh", // Make it fill the full viewport height
                height: "25rem",
                maxHeight: "25rem",
                width: "100%",
                gap: "24px",
              }}
            >
              <svg
                style={{
                  width: "110px",
                  height: "110px",
                }}
                width="141"
                height="141"
                viewBox="0 0 141 141"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="2"
                  y="2"
                  width="137"
                  height="137"
                  rx="68.5"
                  stroke="#676A79"
                  stroke-width="3"
                />
                <path
                  d="M101 49.3118V97.9365C101 104.143 96.5429 106.754 91.1 103.758L74.2572 94.3839C72.4572 93.3994 69.5428 93.3994 67.7428 94.3839L50.9 103.758C45.4571 106.754 41 104.143 41 97.9365V49.3118C41 41.9924 47 36 54.3285 36H87.6714C95 36 101 41.9924 101 49.3118Z"
                  stroke="#676A79"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div
                style={{
                  whiteSpace: "normal",
                  width: "100%",
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: "24px",
                  color: "#676A79",
                  textAlign: "center",
                  // padding: "0 20rem",
                }}
              >
                No Lists Yet
              </div>
            </div>
          </div>
        )
      ) : null}

      {activeAccordion.length > 0 &&
        shoppingListData?.length > 0 &&
        shoppingListData
          .filter((list) => activeAccordion.includes(list?.listId))
          .map((list) => (
            <SingleChat2
              list={list}
              ownerId={list.ownerId || null}
              setActiveAccordion={setActiveAccordion}
              isSmallScreen={isSmallScreen}
              shoppingListData={shoppingListData}
              setShoppingListData={setShoppingListData}
              setLoading={setLoading}
              type={list?.type ?? "myList"}
            />
          ))}
    </>
  );
};

export default ProfileShoppingLists;
